import ReactDOM from "react-dom/client";
import $ from "jquery";
import "react-bootstrap";
import App from "./App";
import {
  clearStaleClientCookie,
  getCliAwSubDomain,
  getHostAwSubDomain,
} from "./helpers/clientHelper";

// Making jQuery globally available
window.$ = window.jQuery = $;

// Direct visits (not from a client site) should not show a leftover client logo.
clearStaleClientCookie();

// On a client subdomain without a matching _cli (typed URL, bookmark, new browser),
// load the client first on ClientAuth, which then returns to the requested page.
const hostAwSubDomain = getHostAwSubDomain();
if (
  hostAwSubDomain &&
  getCliAwSubDomain() !== hostAwSubDomain &&
  !window.location.pathname.toLowerCase().startsWith("/clientauth")
) {
  const returnPath = window.location.pathname + window.location.search;
  window.history.replaceState(
    null,
    "",
    `/clientauth?r=${encodeURIComponent(returnPath)}`
  );
}

const root = ReactDOM.createRoot(document.getElementById("app"));
root.render(<App />);
